import { render, staticRenderFns } from "./Contained.vue?vue&type=template&id=318ded30&scoped=true"
import script from "./Contained.vue?vue&type=script&lang=js"
export * from "./Contained.vue?vue&type=script&lang=js"
import style0 from "./Contained.vue?vue&type=style&index=0&id=318ded30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ded30",
  null
  
)

export default component.exports